// extracted by mini-css-extract-plugin
export default {"fieldSet":"AddPricesInHoursModal_fieldSet__cy3X4","flex":"AddPricesInHoursModal_flex__QmpTA"};